import { render, staticRenderFns } from "./PedidosRepuestosListView.vue?vue&type=template&id=6540649a&scoped=true&lang=pug"
import script from "./PedidosRepuestosListView.vue?vue&type=script&lang=js"
export * from "./PedidosRepuestosListView.vue?vue&type=script&lang=js"
import style0 from "./PedidosRepuestosListView.vue?vue&type=style&index=0&id=6540649a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6540649a",
  null
  
)

export default component.exports